// @flow
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import I18n from 'PMT/i18n/I18n';

import SecurityContext from 'utils/permissions/SecurityContext';

// -- entities
import MenuPartCategory from 'PMT/entities/menu/MenuPartCategory';
import { ImageDropzone, TextInputLocalized } from 'PMT/components/form';

// -- constants
import Constants from 'constants/Constants'
import ViewConstants from 'constants/ViewConstants';
import ApiConstants from 'PMT/constants/ApiConstants';

class Form extends React.Component {
  static propTypes = {
    category: PropTypes.instanceOf(MenuPartCategory).isRequired,
    onChange: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool.isRequired,
  };

  onNameChange = localizedNames => {
    const { category } = this.props;
    category.localizedNames = localizedNames;
    this.props.onChange(category);
  };

  renderImage() {
    return (
      <ImageDropzone
        editOnly={false}
        readOnly={!SecurityContext.restaurantMenu.canEdit()}
        placeholder={
          ViewConstants.Image.RestaurantMenu
            .NO_IMAGE_FOR_MENU_PART_CATEGORY_OPTION
        }
        image={this.props.category.image}
        currentImage={this.props.image.imageData}
        onChange={this.props.image.onChange}
        onRemove={this.props.image.onRemove}
        aspectRatio={ApiConstants.Image.RestaurantMenu.MenuPartCategory.RATIO}
        width={ApiConstants.Image.RestaurantMenu.MenuPartCategory.WIDTH}
        height={ApiConstants.Image.RestaurantMenu.MenuPartCategory.HEIGHT}
        maxSize={ApiConstants.Image.RestaurantMenu.MenuPartCategory.MAX_SIZE}
      />
    );
  }

  render() {
    const { category } = this.props;
    return (
      <div className="">
        <div style={{ marginBottom: 10 }}>
          <TextInputLocalized
            locales={Constants.localesForTranslation}
            values={category.localizedNames}
            isRequired
            className="form-control"
            placeholder="Nom"
            onChange={this.onNameChange}
          />
        </div>

        {this.props.isEditMode && this.renderImage()}
      </div>
    );
  }
}

export default Form;
